import Toggle from '@/shared/Inputs/Toggle'
import SeparateLine from '@/shared/Forms/SeparateLine'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import ProtectedContent from '@/services/rights/ProtectedContent'
import RoleDropdown from '@/pages/Users/components/RoleDropdown'
import { TCreateUserDTO } from '@/pages/Users/users.types.ts'

interface IProps {
  user: Omit<TCreateUserDTO, 'password'>
  onChange: (val: any, name: string) => void
  onUserInfoChange: (val: any, name: string) => void
}

const UserFormFields = (props: IProps) => {
  return (
    <>
      <div className="inline-flex-gap gap8 center">
        <Toggle name="active" checked={props.user.active} onChange={props.onChange} size="large" />
        <span className="text-nm">Учетная запись активна</span>
      </div>
      <SeparateLine />
      <FormField label="Фамилия" required={true}>
        <TextInput
          value={props.user.userInfo.lastName}
          name="lastName"
          onChange={props.onUserInfoChange}
          placeHolder="Введите фамилию"
        />
      </FormField>
      <FormField label="Имя" required={true}>
        <TextInput
          value={props.user.userInfo.firstName}
          name="firstName"
          onChange={props.onUserInfoChange}
          placeHolder="Введите имя"
        />
      </FormField>
      <FormField label="Отчество" required={false}>
        <TextInput
          value={props.user.userInfo.middleName}
          name="middleName"
          onChange={props.onUserInfoChange}
          placeHolder="Введите отчество"
        />
      </FormField>
      <FormField label="Email" required={true}>
        <TextInput value={props.user.email} name="email" onChange={props.onChange} placeHolder="Введите email" />
      </FormField>
      <ProtectedContent adminOnly={true}>
        <FormField label="Роль" required={true}>
          <RoleDropdown value={props.user.roleId} onChange={props.onChange} name="roleId" />
          {props.user.roleId === 1 && (
            <p className="text-nm text-warning">
              Роль администратора дает право на просмотр, редактирование и удаление всех сущеностей в системе.
            </p>
          )}
        </FormField>
      </ProtectedContent>
      <FormField label="Номер телефона">
        <TextInput
          value={props.user.userInfo.phoneNumber}
          name="phoneNumber"
          onChange={props.onUserInfoChange}
          placeHolder="Введите номер телефона"
        />
      </FormField>
      <FormField label="Должность">
        <TextInput
          value={props.user.position}
          name="position"
          onChange={props.onChange}
          placeHolder="Введите должность"
        />
      </FormField>
    </>
  )
}

export default UserFormFields
